export default __webpack_public_path__ + "static/media/MoedasESetas.ff03bd4d.svg";